export default __webpack_public_path__ + "static/contact-main-1c2dc311c59ce9cb32450ca7a8fc0f37.avif";